import { render, staticRenderFns } from "./Polish.vue?vue&type=template&id=671021a3&"
import script from "./Polish.vue?vue&type=script&lang=js&"
export * from "./Polish.vue?vue&type=script&lang=js&"
import style0 from "./Polish.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports